import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenAcsVisitsIndicatorC2Data } from "@/services/esus/indicator/esf/c2/getDetailedCitizensAcsVisitsIndicatorC2";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC2CitizensAcsVisitsHistoryItem } from "./IndicatorEsfC2CitizensAcsVisitsHistoryItem";
import { IndicatorEsfC2CitizensAcsVisitsHistoryInfo } from "./IndicatorEsfC2CitizensAcsVisitsHistoryInfo";

type IndicatorEsfC2CitizensAcsVisitsHistoryProps = {
	citizenWithAcsHomeVisits: DetailedCitizenAcsVisitsIndicatorC2Data;
};

export function IndicatorEsfC2CitizensAcsVisitsHistory({
	citizenWithAcsHomeVisits,
}: Readonly<IndicatorEsfC2CitizensAcsVisitsHistoryProps>) {
	const indicatorEsfC1CitizenHistoryInfo = {
		fullName: citizenWithAcsHomeVisits.fullName ? citizenWithAcsHomeVisits.fullName : "N/A",
		birthdate: citizenWithAcsHomeVisits.birthdate
			? dayjs(citizenWithAcsHomeVisits.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithAcsHomeVisits.cpf
			? formatIdentifier(citizenWithAcsHomeVisits.cpf)
			: citizenWithAcsHomeVisits.cns ?? "",
		motherName: citizenWithAcsHomeVisits.motherName ?? "",
		phone: citizenWithAcsHomeVisits.phone ? phoneFormat(citizenWithAcsHomeVisits.phone) : "",
		address:
			addressConcat(
				citizenWithAcsHomeVisits.street,
				citizenWithAcsHomeVisits.houseNumber,
				citizenWithAcsHomeVisits.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC2CitizensAcsVisitsHistoryInfo {...indicatorEsfC1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Visitas"
				timeLineContents={[
					citizenWithAcsHomeVisits.firstAcsHomeVisit,
					citizenWithAcsHomeVisits.secondAcsHomeVisit,
				]
					.filter((homeVisit) => Boolean(homeVisit))
					.map((homeVisit) => homeVisit!)
					.map<TimeLineContent>((homeVisit) => {
						return {
							content: (
								<IndicatorEsfC2CitizensAcsVisitsHistoryItem homeVisit={homeVisit} />
							),
							eventDate: homeVisit.date
								? dayjs(homeVisit.date).format("DD/MM/YYYY")
								: "N/A",
						};
					})}
			/>
		</>
	);
}
